var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"fancy"},[_c('span',{staticClass:"line"}),_vm._t("default"),_c('span',{staticClass:"line"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }